import styled from 'styled-components/native';

export const Container = styled.ScrollView`
  padding: 16px 16px 0px;
`;
